import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navbarTabs } from '../../constants';
import './NavbarTabs.scss';

interface INavProps {
  isPopup?: boolean;
  setIsOpen?: (value: boolean) => void
}

const NavbarTabs = (props: INavProps) => {
  const { isPopup, setIsOpen } = props;
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('home');

  useEffect(() => {
    const matchedPath = navbarTabs.navbarTabsPathList.find(navPath => location.pathname.startsWith(navPath));
    if (matchedPath) {
      setActiveTab(matchedPath);
    }
  }, [location.pathname]);

  return (
    <div className={`navbar-tabs ${isPopup ? 'flex-column pt-3' : ''}`}>
      {navbarTabs.list.map((item: any, index: number) => {
        const isSelected = activeTab === item.path;
        return (
          <Link to={item.path} onClick={() => setIsOpen?.(false)} className={`navbar-link ${isSelected ? 'active' : ''} ${isPopup && isSelected ? 'resp-active' : ''}`} target={item.target} key={index}>
            <span className={`navbar-items ${isSelected ? 'active' : ''}`}>{item.name}</span>
          </Link>
        );
      })}
    </div>
  );
}

export default NavbarTabs;
